export const unsafelyEntries = <T extends object>(value: T): [keyof T, T[keyof T]][] =>
  Object.entries(value) as [keyof T, T[keyof T]][];

export const unsafelyFromEntries = <T extends PropertyKey, U>(entries: Iterable<readonly [T, U]>): Record<T, U> =>
  Object.fromEntries(entries) as Record<T, U>;

export const unsafelyKeys = <T extends object>(object: T): (keyof T)[] => Object.keys(object) as (keyof T)[];
